module.exports = __webpack_public_path__ + "static/media/fly0250.458c54df.webp";